import { get } from 'lodash';
import Vue from 'vue';
import { NETWORK_LABEL_MAP } from '../../../../constants/networks';
import { ACTIVATION_TYPE_CUSTOM, ACTIVATION_DELIVERY_METHOD_LABEL_MAP } from '../../../../constants/activation-task';

export default {
    data() {
        return {
            tasksToAdd: []
        };
    },
    watch: {
        brief() {
            this.initializeTasks();
        }
    },
    created() {
        if (this.briefTasks) {
            this.initializeTasks();
        }
    },
    computed: {
        requiredTasks() {
            if (this.briefTasks !== null) {
                let tasks = this.briefTasks.filter((task) => task.is_required);

                tasks = [
                    ...tasks,
                    ...this.tasksToAdd.map((taskId) => this.briefTasks.find((task) => task.id === taskId))
                ];

                return tasks;
            }
            return [];
        },
        optionalTasks() {
            if (this.briefTasks !== null) {
                return this.briefTasks.filter(
                    (task) => task.is_required === false && !this.tasksToAdd.includes(task.id)
                );
            }
            return [];
        },
        selectedTasks() {
            if (this.briefTasks !== null) {
                return this.briefTasks.filter((task) => task.is_selected || task.is_required);
            }
            return [];
        },
        contentApprovalTasks() {
            if (this.briefTasks !== null) {
                return this.briefTasks.filter((task) => task.requires_approval === true);
            }
            return [];
        },
        briefTasks() {
            return get(this, 'brief.tasks', []);
        },
        tags() {
            const reportingTags = get(this, 'brief.tracking_tags');

            return {
                mention: reportingTags
                    .filter((tag) => tag.type === 'mention' && tag.is_displayed)
                    .map((tag) => tag.label)
                    .join(', '),
                hashtag: reportingTags
                    .filter((tag) => tag.type === 'hashtag' && tag.is_displayed)
                    .map((tag) => tag.label)
                    .join(', ')
            };
        },
        tagsDescription() {
            const description = get(this, 'brief.customization.content_rights_description', null);

            if (description !== null) {
                return description;
            }

            return '';
        },
        tagPost() {
            if (this.brief.has_tagging_show_on_live === true) {
                const socialAccounts = get(this, 'brief.brand.social_accounts');

                const filteredAccounts = socialAccounts.filter(
                    (account) => account.network.name.toLowerCase() === 'instagram'
                );

                return filteredAccounts.map((account) => account.data.network_name).join(', ');
            }
            return null;
        },
        showTagsBox() {
            return (
                (this.tags.hashtag && this.tags.hashtag.length > 0) ||
                (this.tags.mention && this.tags.mention.length > 0) ||
                (this.tagPost && this.tagPost.length > 0)
            );
        }
    },
    methods: {
        removeTask(taskId) {
            const key = this.tasksToAdd.findIndex((t) => t === taskId);
            Vue.delete(this.tasksToAdd, key);
        },
        addTask(taskId) {
            if (!this.tasksToAdd.includes(taskId)) {
                this.tasksToAdd.push(taskId);
            }
        },
        initializeTasks() {
            const filteredTasks = this.briefTasks.filter((task) => !task.is_required && task.is_selected);
            filteredTasks.forEach((task) => {
                if(!this.tasksToAdd.includes(task.id)) {
                    this.tasksToAdd.push(task.id);
                }
            });
        },
        briefHasTaskType(taskType) {
            return !!this.briefTasks.filter((task) => task.type === taskType);
        },
        isCustomTask(task) {
            return task.type === ACTIVATION_TYPE_CUSTOM;
        },
        getNetworkLabel(task) {
            return NETWORK_LABEL_MAP[task.type];
        },
        getCustomLabel(task) {
            return task.type_delivery_methods?.length > 0
                ? ACTIVATION_DELIVERY_METHOD_LABEL_MAP[task.type_delivery_methods[0]]
                : '';
        },
        getLabel(task) {
            return this.isCustomTask(task) ? this.getCustomLabel(task) : this.getNetworkLabel(task);
        },
        quantityString(task) {
            const quantity = task?.quantity !== 0 ? task?.quantity : '∞';
            return `(${task?.complete_quantity}/${quantity})`;
        }
    }
};
